import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/core/http';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // 4xx é resposta, não falha transitória: repetir só gera carga.
      retry: (count, error) => {
        if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
        return count < 2;
      },
    },
  },
});
